/**
 * How a queued Claude, or a worktree's queued prompt, starts — one of four,
 * picked from `StartModeSelect.vue`, stored as `start_mode`:
 *
 * - `manual`: only by hand.
 * - `ready`: on its own once nothing holds it (server/autoStart.ts).
 * - `under`: once the plan usage is under the week's pace, with room in the
 *   five-hour window, or in wastage (`usageSends`, server/usageStart.ts).
 * - `wastage`: only in wastage — work worth running only on allowance that
 *   would otherwise be lost.
 */
export type StartMode = "manual" | "ready" | "under" | "wastage";

export const START_MODE_VALUES: readonly StartMode[] = ["manual", "ready", "under", "wastage"];

export const isStartMode = (x: unknown): x is StartMode => typeof x === "string" && (START_MODE_VALUES as readonly string[]).includes(x);

/** Started by the plan usage: `under` or `wastage`. */
export const byUsage = (mode: StartMode): mode is "under" | "wastage" => mode === "under" || mode === "wastage";

/** How eagerly each goes, least first: Manual never, Wastage only in wastage,
 *  Under in under or wastage, Ready once nothing holds it. */
const EAGERNESS: Record<StartMode, number> = { manual: 0, wastage: 1, under: 2, ready: 3 };

/** Whether `a` goes less readily than `b`. */
export const lessEager = (a: StartMode, b: StartMode): boolean => EAGERNESS[a] < EAGERNESS[b];
